import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionClient } from '../model';

const CANDIDATES_URL = '/collections/candidates';

export function useCollectionClients(location: string, enabled = true) {
  return useGet<CollectionClient[]>({
    url: CANDIDATES_URL,
    params: { location },
    enabled,
  });
}
